import { Observable } from 'rxjs';

export class FileUploadUtilities {
    public static convertFileToBase64(file: File): Observable<string> {
        return new Observable<string>((observer): void => {
            const reader = new FileReader();

            reader.onload = (): void => {
                observer.next(reader.result as string);
                observer.complete();
            };

            reader.onerror = (error): void => observer.error(error);

            reader.readAsDataURL(file);
        });
    }

    public static removeBase64Prefix(base64String: string): string {
        const base64Prefix = 'base64,';
        const base64StartIndex = base64String.indexOf(base64Prefix);
        if (base64StartIndex !== -1) {
            return base64String.substring(base64StartIndex + base64Prefix.length);
        }
        return base64String;
    }
}
